import React, { useRef } from 'react';

import { FormControl, FormLabel, useUpdateEffect } from '@chakra-ui/react';

import GooglePlacesAutocomplete, {
  geocodeByAddress,
} from 'react-google-places-autocomplete';

import { PlacesAutocompleteProps } from './PlacesAutocomplete.props';

const API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
const inputBgColor = '#fff';

const defaultInputStyle = {
  container: (provided: any) => ({
    ...provided,
    width: '100%',
    background: inputBgColor,
    paddingLeft: 3,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: '#ccc8',
  }),
  dropdownIndicator: (styles: any) => ({
    ...styles,
    background: inputBgColor,

    display: 'none',
  }),
  indicatorSeparator: (styles: any) => ({
    ...styles,
    background: inputBgColor,

    display: 'none',
  }),
  input: (provided: any) => ({
    ...provided,
    color: 'blue',
    background: inputBgColor,

    flex: '1',
    caretColor: 'white',
  }),
  control: (provided: any) => ({
    ...provided,
    background: inputBgColor,
    border: 'transparent',
    borderRadius: 6,
  }),
};

const PlacesAutocompleteView = ({
  name = '',
  searchOptions,
  onChange,
  onSelect,
  labelText,
  defaultInputValue = '',
  value,
  isRequired,
  isReadOnly,
  ...props
}: PlacesAutocompleteProps): JSX.Element => {
  const inputRef = useRef<any>(null);

  useUpdateEffect(() => {
    if (!value) {
      return;
    }

    (inputRef?.current as any).select.state.inputValue = value;
  }, [value]);

  return (
    <FormControl mt={3} flex={1} isRequired={isRequired}>
      {labelText && (
        <FormLabel
          htmlFor={name}
          fontSize="12px"
          fontWeight="600"
          color="grey"
          textTransform="capitalize"
          {...props.labelProps}>
          {labelText}
        </FormLabel>
      )}
      <GooglePlacesAutocomplete
        apiKey={API_KEY}
        selectProps={
          {
            ref: inputRef,
            onChange: async (data: any) => {
              /**
               * Avoid google api call without an address
               */
              let result: google.maps.GeocoderResult[] = [];
              if (Boolean(data)) {
                result = await geocodeByAddress(data?.label);
              }
              onSelect?.(result);
            },
            isClearable: true,
            styles: defaultInputStyle,
            defaultInputValue,
            isReadOnly,
          } as any
        }
        autocompletionRequest={{
          componentRestrictions: {
            country: 'us',
          },
          types: ['address'],
        }}
        debounce={200}
      />
    </FormControl>
  );
};

export default React.memo(PlacesAutocompleteView);
